
    import React from 'react';
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
    import SpriteSymbolComponent from "../../components/Svg/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "exclamation-orange--sprite",
  "use": "exclamation-orange--sprite-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"exclamation-orange--sprite\"><path d=\"M13 7v7m12-1c0 6.627-5.373 12-12 12S1 19.627 1 13 6.373 1 13 1s12 5.373 12 12zm-11.25 5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0z\" stroke=\"url(#exclamation-orange--sprite_exclamation-orange_svg__a)\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><defs><linearGradient id=\"exclamation-orange--sprite_exclamation-orange_svg__a\" x1=\"11.754\" y1=\"-12.758\" x2=\"14.249\" y2=\"38.835\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#F79F5D\" /><stop offset=\"1\" stop-color=\"#E84B38\" /></linearGradient></defs></symbol>"
});
    sprite.add(symbol);

    export default class ExclamationOrangeSpriteSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="exclamation-orange--sprite" viewBox="0 0 26 26" {...this.props} />;
      }
    }
  